import { render, staticRenderFns } from "./GenerateInvoice.vue?vue&type=template&id=4ccb46d8"
import script from "./GenerateInvoice.vue?vue&type=script&lang=js"
export * from "./GenerateInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports